<template>
  <div data-qa="asda-footer" v-html="footerContent"></div>
</template>

<script>
export default {
  name: 'AsdaFooter',
  data () {
    return {
      footerContent: ''
    }
  },
  beforeMount () {
    this.setFooter()
  },
  methods: {
    async getFooter () {
      try {
        const res = await fetch('/uk/footer.html?name=porta')
        return res.text()
      } catch (error) {
        if (window.newrelic) {
          window.newrelic.noticeError(error)
        }
      }
    },
    async setFooter () {
      const res = await this.getFooter()
      const parsed = new DOMParser().parseFromString(res, 'text/html')
      const parsedScript = parsed.querySelector('script')
      this.footerContent = parsed.querySelector('body').innerHTML

      if (parsedScript) {
        const scriptStr = parsedScript.innerText
        const script = document.createElement('script')

        parsedScript.remove()

        script.textContent = scriptStr

        await new Promise(resolve => {
          setTimeout(() => {
            document.querySelector('body').appendChild(script)
            resolve()
          }, 1)
        })
      }
    }
  }
}
</script>
